<template>
  <v-flex xs12 sm10 offset-sm1>
    <v-card class="pa-4">
      <v-form>
        <v-container>
          <v-layout row wrap>
            
            <v-flex xs12 sm6>
              <v-text-field
                v-model="title"
                :rules="[rules.required, rules.counter]"
                label="Title"
                counter
                maxlength="20"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6>
              <v-text-field
                v-model="email"
                :rules="[rules.required, rules.email]"
                label="E-mail"
              ></v-text-field>
            </v-flex>

            <v-flex xs6>
              <v-subheader>Standard</v-subheader>
            </v-flex>
            <v-flex xs6>
              <v-select
                :items="items"
                v-model="e1"
                label="Select"
                single-line
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-subheader>Standard with focus</v-subheader>
            </v-flex>
            <v-flex xs6>
              <v-select
                :items="items"
                v-model="e2"
                label="Select"
                class="input-group--focused"
                item-value="text"
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-subheader>Error</v-subheader>
            </v-flex>
            <v-flex xs6>
              <v-select
                :items="items"
                v-model="e3"
                :error-messages="['Please select an option']"
                label="Select"
                item-value="text"
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-subheader>Disabled</v-subheader>
            </v-flex>
            <v-flex xs6>
              <v-select
                :items="items"
                v-model="e4"
                label="Select"
                disabled
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-flex>
</template>
<script>
  export default {
    name: 'ChangePassword',
    data () {
      return {
        e1: null,
        e2: null,
        e3: null,
        e4: null,
        items: [
          { text: 'State 1' },
          { text: 'State 2' },
          { text: 'State 3' },
          { text: 'State 4' },
          { text: 'State 5' },
          { text: 'State 6' },
          { text: 'State 7' }
        ],
        states: [
          'Alabama', 'Alaska', 'American Samoa', 'Arizona',
          'Arkansas', 'California', 'Colorado', 'Connecticut',
          'Delaware', 'District of Columbia', 'Federated States of Micronesia',
          'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho',
          'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
          'Louisiana', 'Maine', 'Marshall Islands', 'Maryland',
          'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
          'Missouri', 'Montana', 'Nebraska', 'Nevada',
          'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
          'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio',
          'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico',
          'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee',
          'Texas', 'Utah', 'Vermont', 'Virgin Island', 'Virginia',
          'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
        ],
        title: 'Preliminary report',
        email: '',
        rules: {
          required: value => !!value || 'Required.',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
        }
      }
    },
    created: function(){
      this.$root.breadcrumbs = [
          {
            text: 'Dashboard',
            disabled: false,
            href: '/dashboard'
          },
          {
            text: 'My Account',
            disabled: true,
          },
          {
            text: 'Change Password',
            disabled: true
          }
      ]
    }
  }
</script>